module.exports = __webpack_public_path__ + "assets/terms/termos-ec.5cb65b1d.pdf";